import type { DiagramSpec } from '../types'
import { vidmaxDiagram } from './vidmax'

/** Variant 1: Default (full descriptions, no fields on node) */
export const v1Default: DiagramSpec = {
  ...vidmaxDiagram,
  id: 'v1-default',
  name: 'V1: Default',
  description: 'Full descriptions, smoothstep edges, 240w nodes',
}

/** Variant 2: Compact — narrower nodes, truncated, tight spacing */
export const v2Compact: DiagramSpec = {
  ...vidmaxDiagram,
  id: 'v2-compact',
  name: 'V2: Compact',
  description: 'Truncated descriptions, narrow nodes, tight gaps',
  preferences: {
    truncateDescriptions: true,
    nodeWidth: 180,
    rankSpacing: 100,
    nodeGap: 20,
    fitPadding: 0.1,
  },
}

/** Variant 3: Fields on node — shows metadata inline */
export const v3Fields: DiagramSpec = {
  ...vidmaxDiagram,
  id: 'v3-fields',
  name: 'V3: Fields on Node',
  description: 'Key-value fields rendered directly on each card',
  preferences: {
    showFieldsOnNode: true,
    nodeWidth: 260,
    rankSpacing: 180,
  },
}

/** Variant 4: Straight edges, no layer bands, wide spacing */
export const v4Minimal: DiagramSpec = {
  ...vidmaxDiagram,
  id: 'v4-minimal',
  name: 'V4: Minimal',
  description: 'Straight edges, no layer bands, wide spacing',
  preferences: {
    edgeStyle: 'straight',
    showLayerBands: false,
    rankSpacing: 200,
    nodeGap: 60,
    edgeColor: '#4a6a8a',
  },
}

/** Variant 5: Bezier edges, custom theme, max density */
export const v5Dense: DiagramSpec = {
  ...vidmaxDiagram,
  id: 'v5-dense',
  name: 'V5: Dense + Bezier',
  description: 'Bezier edges, custom colors, maximum density',
  preferences: {
    edgeStyle: 'bezier',
    edgeColor: '#6366f1',
    background: '#0a0e1a',
    nodeWidth: 200,
    rankSpacing: 110,
    nodeGap: 16,
    fitPadding: 0.08,
    maxZoom: 1.5,
  },
}
